// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-button-container[data-v-f6b6875e]{-webkit-backdrop-filter:blur(2.5px);backdrop-filter:blur(2.5px);background:hsla(0,0%,100%,.1);border-radius:124px;gap:10px;height:40px;padding:0 16px;width:40px}.close-button-container svg[data-v-f6b6875e]{flex-shrink:0;height:20px;width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
